<template>
  <div>
    <nav-bar :title="titlePage" />
    <div class="mobile py-4">
      <confirm-modal
        :title="confirmModalData.title"
        :confirm-button="confirmModalData.confirmButton"
      >
        {{ confirmModalData.text }}
      </confirm-modal>
      <modal-update-reward :rewardData="rewardDataToEdit" @updateReward="updateReward" />
      <modal-opening-button-new-reward
        v-if="!userIsAParent || parentCanEdit"
      ></modal-opening-button-new-reward>
      <modal-redeem-reward
        :rewardName="rewardModal.name"
        :rewardImg="rewardModal.image"
      ></modal-redeem-reward>
      <reward-skeleton v-if="loading"></reward-skeleton>
      <div v-else class="atm-desktop-max-width">
        <b-alert show variant="primary" class="d-flex justify-content-between p-2 mx-2 mx-lg-5">
          <small> {{ textCoinsInformation }} </small>
          <div class="d-flex justify-content-center align-items-center">
            <b-img :src="require('@/assets/coin.png')" class="small-coin mr-1"></b-img>
            <p class="small font-weight-bolder mb-0 d-inline-block">
              {{ coinsInformation.Banked }}
            </p>
          </div>
        </b-alert>
        <b-row
          class="d-flex gap-4 justify-content-center align-items-stretch w-100 atm-desktop-max-width px-4 py-4 mx-auto"
        >
          <div
            v-if="rewardsChild"
            class="d-flex gap-4 flex-wrap justify-content-center align-items-stretch w-100 mt-4"
          >
            <div
              v-for="(reward, id) in rewardsChild"
              :key="`noClaimed_${id}`"
              class="position-relative rewardCard atm-rounded atm-shadow"
            >
              <reward-card
                :reward-data="reward"
                :userIsParent="userIsAParent"
                :coinsBanked="coinsInformation.Banked"
                @changeFavorite="changeFavorite(reward)"
                @deleteReward="showModalDeleteReward(reward)"
                @claimReward="showClaimReward(reward)"
                @openModalUpdateReward="openModalUpdateReward"
              />
            </div>
          </div>
          <div v-else>
            <span
              class="material-icons border-2 full-icon rounded-circle align-middle mt-5 mb-4 border-0"
            >
              card_giftcard
            </span>
            <p class="h4 text-xmuted mx-4">
              <span class="text-capitalize">
                {{ sessionStore.parentName }}
              </span>
              has not added any rewards yet.
            </p>
          </div>
          <div
            v-if="claimedRewards"
            class="d-flex gap-4 flex-wrap justify-content-center align-items-stretch w-100 mt-4"
          >
            <h2 class="mr-auto font-weight-600 w-100">Rewards redeemed</h2>
            <div
              v-for="(reward, id) in claimedRewards"
              :key="`claimed_${id}`"
              class="position-relative rewardCard atm-rounded atm-shadow"
            >
              <reward-card
                :reward-data="reward"
                :userIsParent="userIsAParent"
                :coinsBanked="coinsInformation.Banked"
                @deleteReward="showModalDeleteReward(reward)"
                @claimReward="showClaimReward(reward)"
                @openModalUpdateReward="openModalUpdateReward"
              />
            </div>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import { NavBar } from '@/common/components';
import { useSessionStore } from '@/common';
import {
  getCoinsInformation,
  getRewardsChild,
  setUpdateReward,
  setDeleteReward,
  setClaimReward,
} from '../services';
import { ConfirmModal } from '@/common/components';
import rewardCard from '../components/RewardCard.vue';
import notificationToastMixin from '@/Mixins/notificationToast.mixin';
import RewardSkeleton from '../components/skeletons/RewardSkeleton.vue';
import ModalOpeningButtonNewReward from '../components/buttons/ModalOpeningButtonNewReward';
import ModalUpdateReward from '@/gamification/components/modal/ModalUpdateReward';
import ModalRedeemReward from '@/gamification/components/modal/ModalRedeemReward';

export default {
  components: {
    NavBar,
    rewardCard,
    ConfirmModal,
    RewardSkeleton,
    ModalOpeningButtonNewReward,
    ModalUpdateReward,
    ModalRedeemReward,
  },
  data() {
    const sessionStore = useSessionStore();
    return {
      rewardDataToEdit: {},
      confirmModalData: {
        title: 'Confirm',
        text: 'text',
        confirmButton: () => {},
      },
      sessionStore,
      loading: false,
      coinsInformation: {},
      rewardsChild: {},
      claimedRewards: {},
      rewardModal: {
        name: '',
        image: '',
      },
    };
  },
  mixins: [notificationToastMixin],
  computed: {
    userIsAParent() {
      return this.sessionStore.userIsAParent;
    },
    titlePage() {
      return this.userIsAParent ? `${this.childName}'s Rewards` : 'My Rewards';
    },
    childId() {
      return this.userIsAParent ? this.sessionStore.childSelectedId : this.sessionStore.userId;
    },
    childName() {
      return this.sessionStore.childName;
    },
    textCoinsInformation() {
      return this.userIsAParent ? `${this.childName}'s banked coins` : 'My banked coins';
    },
    parentCanEdit() {
      return this.sessionStore.getCurrentChild.parentCanEdit;
    },
  },
  async mounted() {
    if (this.$route.params.markComplete) {
      this.notificationToast({
        message: 'Reward created successfully',
        variant: 'primary',
        title: 'Success',
      });
    }
    this.getRewardsChild();
    this.getCoinsInformation();
  },
  methods: {
    async changeFavorite(reward) {
      try {
        const { favorite, id } = reward;
        const body = {
          favorite: !favorite,
        };
        await setUpdateReward(id, body);
        this.getRewardsChild();
        this.notificationToast({
          message: 'Favorite rewards updated',
          variant: 'primary',
          title: 'Success',
        });
      } catch (error) {
        this.notificationToast({
          message: 'Already has the maximum of 3 favorite rewards',
          variant: 'danger',
          title: 'Error',
        });
        console.error(error);
      }
    },
    async getRewardsChild() {
      try {
        this.loading = true;
        const rewardsChildTotal = await getRewardsChild(this.childId);
        this.rewardsChild = rewardsChildTotal.filter((reward) => !reward.claimed);
        this.claimedRewards = rewardsChildTotal.filter((reward) => reward.claimed);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    async getCoinsInformation() {
      try {
        this.coinsInformation = await getCoinsInformation(this.childId);
      } catch (error) {
        console.error(error);
      }
    },
    async showModalDeleteReward(reward) {
      try {
        this.confirmModalData.title = reward.name;
        this.confirmModalData.text = 'Do you want to delete this reward?';
        this.confirmModalData.confirmButton = () => {
          this.deleteReward(reward.name, reward.id);
        };
        this.$bvModal.show('confirmModal');
      } catch (error) {
        console.error(error);
      }
    },
    async deleteReward(rewardName, rewardId) {
      try {
        await setDeleteReward(rewardId);
        this.getRewardsChild();
        this.notificationToast({
          message: `${rewardName} removed from awards`,
          variant: 'primary',
          title: 'Success',
        });
      } catch (error) {
        console.error(error);
      }
    },
    async showClaimReward(reward) {
      try {
        this.confirmModalData.title = `Ready to Claim: ${reward.name}`;
        this.confirmModalData.text = `Do you want to claim this reward for ${reward.coins_required} coins?`;
        this.confirmModalData.confirmButton = () => {
          this.claimReward(reward);
        };
        this.$bvModal.show('confirmModal');
      } catch (error) {
        console.error(error);
      }
    },
    async claimReward({ id, name, attachment }) {
      try {
        await setClaimReward(id);
        await this.getCoinsInformation();
        await this.getRewardsChild();
        this.openModalRewardRedeemed({ name, attachment });
      } catch (error) {
        console.error(error);
      }
    },
    openModalRewardRedeemed({ name, attachment }) {
      this.rewardModal.name = name;
      this.rewardModal.image = attachment;
      this.$bvModal.show('redeem-modal');
    },
    openModalUpdateReward({ rewardData }) {
      this.rewardDataToEdit = rewardData;
      this.$bvModal.show('updateReward');
    },
    async updateReward({ rewardDataToBeEdited }) {
      const { data, reward_id } = rewardDataToBeEdited;
      await setUpdateReward(reward_id, data);
      this.getRewardsChild();
    },
  },
};
</script>
<style lang="scss" scoped>
.rewardCard {
  min-width: 160px;
  max-width: 260px;
  flex-grow: 1;
}
</style>
